import Image from "next/image";
import IMAGES from "@/public/assets/img";

export default function IndustryUseCases({ data }) {
  const { sectionTitle, mainHeading, cases } = data;

  return (
    <section className="py-sp-100 sm:py-sp-big">
      <div className="container px-3 flex sm:flex-col items-center gap-12 sm:gap-4">
        {/* Left Image */}
        <Image
          src={data.image}
          alt="Industry Use Cases"
          width={324}
          height={270}
          className="h-auto"
        />

        <div className="sm:w-full">
          <p className="text-base2 text-baseBlack mb-2 font-medium sm:text-lg">
            {sectionTitle}
          </p>
          <h2 className="text-heading text-baseBlack mb-5 sm:text-xl">{mainHeading}</h2>
          {/* Cases */}
          <div className="flex flex-wrap">
            {cases.map((item) => (
              <div key={item.id} className="flex items-center gap-1 w-1/2 mb-3 sm:w-full">
                <Image
                  src={IMAGES.ImportFactoring.yes}
                  width={24}
                  height={24}
                />
                <p className="text-baseBlack text-[22px] sm:text-base">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
